import { render, staticRenderFns } from "./sharePopup.vue?vue&type=template&id=a542ca70&scoped=true"
import script from "./sharePopup.vue?vue&type=script&lang=js"
export * from "./sharePopup.vue?vue&type=script&lang=js"
import style0 from "./sharePopup.vue?vue&type=style&index=0&id=a542ca70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a542ca70",
  null
  
)

export default component.exports